<template>
  <div id="state_detail">
    <div class="return">
      <el-link :underline="false" @click="$router.go(-1)">&lt; 返回</el-link>
    </div>
    <el-tabs style="min-height:800px" type="border-card" v-model="activeName">
      <el-tab-pane :label="is_add == 1?'添加库存':'查看详情'" name="1">
        <div class="table_box">
          <table>
            <tr>
              <td colspan="2">
                <el-input type="text" v-model="form.name">
                  <template style="background-color:#fff" slot="prepend">
                    <span style="color:red">*</span>名称:
                  </template>
                </el-input>
              </td>
              <td>
                <el-input type="text" v-model="form.number">
                  <template style="background-color:#fff" slot="prepend">
                    <span style="color:red">*</span>数量:
                  </template>
                </el-input>
              </td>
              <td>
                <el-input type="text" v-model="form.specification">
                  <template style="background-color:#fff" slot="prepend">
                    <span style="color:red">*</span>规格:
                  </template>
                </el-input>
              </td>
              <td>
                <el-input type="text" v-model="form.price">
                  <template style="background-color:#fff" slot="prepend">
                    <span style="color:red">*</span>单价:
                  </template>
                </el-input>
              </td>
            </tr>
            <tr>
              <td>
                <el-input type="text" v-model="form.brand">
                  <template style="background-color:#fff" slot="prepend">
                    <span style="color:red">*</span>品牌:
                  </template>
                </el-input>
              </td>
              <td>
                <el-input type="text" v-model="form.item_no">
                  <template style="background-color:#fff" slot="prepend">
                    <span style="color:red">*</span>货号:
                  </template>
                </el-input>
              </td>
              <td>
                <el-input type="text" v-model="form.buy_company">
                  <template style="background-color:#fff" slot="prepend">订购公司:</template>
                </el-input>
              </td>
              <td>
                <el-input type="text" v-model="form.buy_date">
                  <template style="background-color:#fff" slot="prepend">订购日期:</template>
                </el-input>
              </td>
              <td>
                <el-input type="text" v-model="form.close_date">
                  <template style="background-color:#fff" slot="prepend">失效日期:</template>
                </el-input>
              </td>
            </tr>
            <tr>
              <td>
                <el-input type="text" v-model="form.molecule">
                  <template style="background-color:#fff" slot="prepend">分子量:</template>
                </el-input>
              </td>
              <td>
                <el-input type="text" v-model="form.CAS">
                  <template style="background-color:#fff" slot="prepend">CAS号:</template>
                </el-input>
              </td>
              <td>
                <el-input type="text" v-model="form.purity">
                  <template style="background-color:#fff" slot="prepend">纯度:</template>
                </el-input>
              </td>
              <td>
                <el-input type="text" v-model="form.host">
                  <template style="background-color:#fff" slot="prepend">宿主:</template>
                </el-input>
              </td>
              <td>
                <el-input type="text" v-model="form.relation">
                  <template style="background-color:#fff" slot="prepend">反应种属:</template>
                </el-input>
              </td>
            </tr>
            <tr>
              <td>
                <el-input type="text" v-model="form.group">
                  <template style="background-color:#fff" slot="prepend">课题组:</template>
                </el-input>
              </td>
              <td>
                <el-select v-model="project_value" filterable placeholder="项目分类:">
                  <el-option v-for="item in project" :key="item" :label="item" :value="item"></el-option>
                </el-select>
              </td>
              <td>
                <el-select v-model="class_value" filterable placeholder="资金分类:">
                  <el-option v-for="item in money_class" :key="item" :label="item" :value="item"></el-option>
                </el-select>
              </td>
              <td>
                <el-input type="text" v-model="form.member">
                  <template style="background-color:#fff" slot="prepend">负责人:</template>
                </el-input>
              </td>
              <td>
                <el-input type="text" v-model="form.buy_member">
                  <template style="background-color:#fff" slot="prepend">
                    <span style="color:red">*</span>申购人:
                  </template>
                </el-input>
              </td>
            </tr>
            <tr>
              <td>
                <el-select v-model="choose_class" filterable placeholder="分类:">
                  <el-option v-for="item in class_class" :key="item" :label="item" :value="item"></el-option>
                </el-select>
              </td>
              <td>
                <el-input type="text" v-model="form.use">
                  <template style="background-color:#fff" slot="prepend">应用:</template>
                </el-input>
              </td>
              <td>
                <el-input type="text" v-model="form.save">
                  <template style="background-color:#fff" slot="prepend">储存条件:</template>
                </el-input>
              </td>
              <td>
                <el-select v-model="save_address" filterable placeholder="存放位置:">
                  <el-option
                    v-for="item in save_address_list"
                    :key="item"
                    :label="item"
                    :value="item"
                  ></el-option>
                </el-select>
              </td>
              <td>
                <el-input type="text" v-model="form.location">
                  <template style="background-color:#fff" slot="prepend">具体位置:</template>
                </el-input>
              </td>
            </tr>
            <tr>
              <td>
                <el-input type="text" v-model="form.save_rule">
                  <template style="background-color:#fff" slot="prepend">存放规范:</template>
                </el-input>
              </td>
              <td colspan="2">
                <el-input type="text" v-model="form.safety">
                  <template style="background-color:#fff" slot="prepend">安全措施:</template>
                </el-input>
              </td>
              <td colspan="2">
                <el-input type="text" v-model="form.remark">
                  <template style="background-color:#fff" slot="prepend">备注:</template>
                </el-input>
              </td>
            </tr>
          </table>
        </div>
        <div v-if="is_add == 0">
          <el-table :data="use_log_list" border style="width: 93%;margin:50px auto 0 auto;">
            <el-table-column align="center" type="index" prop="date" label="序号" width="50"></el-table-column>
            <el-table-column align="center" prop="date" label="日期" width="100"></el-table-column>
            <el-table-column align="center" prop="content" label="试验内容" width="100"></el-table-column>
            <el-table-column align="center" prop="before" label="试验前总量" width="100"></el-table-column>
            <el-table-column align="center" prop="use" label="试验用量" width="80"></el-table-column>
            <el-table-column align="center" prop="unit" label="单位" width="50"></el-table-column>
            <el-table-column align="center" prop="surplus" label="剩余" width="80"></el-table-column>
            <el-table-column align="center" prop="member1" label="使用人1" width="100"></el-table-column>
            <el-table-column align="center" prop="member2" label="使用人2" width="100"></el-table-column>
            <el-table-column align="center" prop="remark" label="备注"></el-table-column>
          </el-table>
        </div>
        <div v-if="show_add_log == 1" style="margin-top:10px">
          <table style="width:897px">
            <tr>
              <td style="width:100px">
                <el-input type="text" v-model="date" placeholder="日期/自动填充"></el-input>
              </td>
              <td style="width:100px">
                <el-input type="text" v-model="log.content" placeholder="试验内容"></el-input>
              </td>
              <td style="width:100px">
                <el-input
                  oninput="value=value.replace(/[^\d]/g,'')"
                  type="text"
                  v-model="before"
                  placeholder="试验前总量"
                ></el-input>
              </td>
              <td style="width:80px">
                <el-input
                  @change="count()"
                  oninput="value=value.replace(/[^\d]/g,'')"
                  type="text"
                  v-model="log.use"
                  placeholder="本次使用"
                ></el-input>
              </td>
              <td style="width:50px">
                <el-input type="text" v-model="log.unit" placeholder="单位"></el-input>
              </td>
              <td style="width:80px">
                <el-input
                  oninput="value=value.replace(/[^\d]/g,'')"
                  type="text"
                  v-model="surplus"
                  placeholder="剩余"
                ></el-input>
              </td>
              <td style="width:100px">
                <el-input type="text" v-model="log.member1" placeholder="使用人1"></el-input>
              </td>
              <td style="width:100px">
                <el-input type="text" v-model="log.member2" placeholder="使用人2"></el-input>
              </td>
              <td style>
                <el-input type="text" v-model="log.remark" placeholder="备注"></el-input>
              </td>
            </tr>
          </table>
        </div>
        <div v-if="is_add == 0" class="lv3Text" style="padding:20px 0 0 35px;">
          <span style="cursor: pointer;" @click="show_add_log = 1">
            <span style="margin-right:5px">
              <i class="fas fa-plus-square fa-lg"></i>
            </span>
            添加使用记录
          </span>
          <span style="float:right;cursor: pointer">
            <a
              v-if="use_log_list.length > 0"
              class="lv3Text"
              target="_blank"
              :href="serve + '/personal/export_inven_use?mobile='+mobile+'&token='+token+'&inven_id='+id"
            >导出使用记录</a>
          </span>
        </div>
        <div style="padding:50px">
          <button class="save_button" @click="submit()">保存</button>
          <span style="color:red">(*为必填选项)</span>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
export default {
  data() {
    return {
      serve: this.$store.state.serve,
      form: {
        mobile: this.$cookies.get("user"),
        token: this.$cookies.get("token"),
        name: "",
        number: "",
        specification: "",
        price: "",
        brand: "",
        item_no: "",
        buy_company: "",
        buy_date: "",
        buy_member: ""
      },
      mobile: this.$cookies.get("user"),
      token: this.$cookies.get("token"),
      activeName: "1",
      id: "",
      is_add: 0,
      project: [],
      project_value: "",
      money_class: [],
      class_value: "",
      class_class: ["试剂", "抗体", "耗材", "仪器", "技术服务"],
      choose_class: "",
      save_address_list: [],
      save_address: "",
      log: {},
      show_add_log: 0,
      use_log_list: [],
      today: "",
      last_log: "",
      date: "",
      before: "",
      surplus: ""
    };
  },
  watch: {
    $route: {
      handler(route) {
        const that = this;
        if (route.path == "/user/harmful_detail/0") {
          that.form = {
            mobile: this.$cookies.get("user"),
            token: this.$cookies.get("token"),
            name: "",
            number: "",
            specification: "",
            price: "",
            brand: "",
            item_no: "",
            buy_company: "",
            buy_date: "",
            buy_member: ""
          };
        }
      },
      deep: true
    }
  },
  created() {
    this.get_address();
    this.get_id();
    this.get_project();
    this.get_money_class();
    if (this.is_add == 0) {
      this.get_use_log();
    }
    var myDate = new Date();
    let Year = myDate.getFullYear();
    let Month = myDate.getMonth() + 1;
    let Day = myDate.getDate();
    this.date = Year + "-" + Month + "-" + Day;
  },
  methods: {
    count() {
      this.surplus = this.before - this.log.use;
    },
    get_detail(e) {
      this.axios
        .get(this.serve + "/personal/get_inventory_detail", {
          params: {
            mobile: this.$cookies.get("user"),
            token: this.$cookies.get("token"),
            id: e
          }
        })
        .then(res => {
          if (res.data.status == "success") {
            let data = res.data.data;
            let n;
            this.form = data;
            for (n in data) {
              if (n == "money_class") {
                this.class_value = data[n];
              }
              if (n == "product_class") {
                this.choose_class = data[n];
              }
              if (n == "address") {
                this.save_address = data[n];
              }
              if (n == "project") {
                this.project_value = data[n];
              }
            }
          } else {
            this.$message({
              showClose: true,
              type: "error",
              message: res.data.msg,
              offset: 400
            });
          }
        });
    },
    get_address() {
      this.axios
        .get(this.serve + "/personal/save_address_list", {
          params: {
            mobile: this.$cookies.get("user"),
            token: this.$cookies.get("token")
          }
        })
        .then(res => {
          let address = [];
          if (res.data.status == "success") {
            let data = res.data.data;

            for (let n in data) {
              address[n] = data[n].address;
            }
          } else {
            address = [];
          }
          this.save_address_list = address;
        });
    },
    get_id() {
      this.id = this.$route.params.id;
      if (this.id == 0) {
        this.is_add = 1;
      } else {
        this.is_add = 0;
        this.get_detail(this.id);
      }
    },
    get_project() {
      this.axios
        .get(this.serve + "/personal/host_name_list", {
          params: {
            mobile: this.$cookies.get("user"),
            token: this.$cookies.get("token")
          }
        })
        .then(res => {
          if (res.data.data) {
            this.project = res.data.data;
          }
        });
    },
    get_money_class() {
      this.axios
        .get(this.serve + "/personal/project_class", {
          params: {
            mobile: this.$cookies.get("user"),
            token: this.$cookies.get("token")
          }
        })
        .then(res => {
          for (var item of res.data) {
            for (var item2 of item.children) {
              this.money_class.push(item2);
            }
          }
        });
    },
    get_use_log() {
      this.axios
        .get(this.serve + "/personal/use_inventory_log", {
          params: {
            mobile: this.$cookies.get("user"),
            token: this.$cookies.get("token"),
            inven_id: this.id
          }
        })
        .then(res => {
          if (res.data.data) {
            this.use_log_list = res.data.data.results;
            let leng = res.data.data.results.length;
            this.last_log = this.use_log_list[0];
            this.before = this.last_log.surplus;
          } else {
            this.use_log_list = [];
          }
        });
    },
    submit() {
      if (this.show_add_log == 1) {
        this.log.mobile = this.$cookies.get("user");
        this.log.token = this.$cookies.get("token");
        this.log.id = this.id;
        this.log.date = this.date;
        this.log.before = this.before;
        this.log.surplus = this.surplus;
        this.axios
          .get(this.serve + "/personal/get_inventory", {
            params: this.log
          })
          .then(res => {
            if (res.data.status == "success") {
              this.$message({
                showClose: true,
                type: "success",
                message: "使用记录添加成功",
                offset: 400
              });
              this.show_add_log = 0;
              this.get_use_log();
            } else {
              this.$message({
                showClose: true,
                type: "error",
                message: res.data.msg,
                offset: 400
              });
            }
          });
        this.log = [];
        this.before = this.surplus;
        this.surplus = "";
        return;
      }

      if (this.form.name == "") {
        this.$message({
          showClose: true,
          type: "error",
          message: "请填写名称",
          offset: 400
        });
        return;
      }
      if (this.form.number == "") {
        this.$message({
          showClose: true,
          type: "error",
          message: "请填写数量",
          offset: 400
        });
        return;
      }
      if (this.form.specification == "") {
        this.$message({
          showClose: true,
          type: "error",
          message: "请填写规格",
          offset: 400
        });
        return;
      }
      if (this.form.price == "") {
        this.$message({
          showClose: true,
          type: "error",
          message: "请填写单价",
          offset: 400
        });
        return;
      }
      if (this.form.brand == "") {
        this.$message({
          showClose: true,
          type: "error",
          message: "请填写品牌",
          offset: 400
        });
        return;
      }
      if (this.form.item_no == "") {
        this.$message({
          showClose: true,
          type: "error",
          message: "请填写货号",
          offset: 400
        });
        return;
      }
      if (this.project_value == "") {
        this.$message({
          showClose: true,
          type: "error",
          message: "请选择项目分类",
          offset: 400
        });
        return;
      }
      if (this.class_value == "") {
        this.$message({
          showClose: true,
          type: "error",
          message: "请选择资金分类",
          offset: 400
        });
        return;
      }
      if (this.choose_class == "") {
        this.$message({
          showClose: true,
          type: "error",
          message: "请选择分类",
          offset: 400
        });
        return;
      }
      if (this.save_address == "") {
        this.$message({
          showClose: true,
          type: "error",
          message: "请选择存放地址",
          offset: 400
        });
        return;
      }
      if (this.form.buy_member == "") {
        this.$message({
          showClose: true,
          type: "error",
          message: "请填写申购人",
          offset: 400
        });
        return;
      }
      this.form.project = this.project_value;
      this.form.money_class = this.class_value;
      this.form.class = this.choose_class;
      this.form.save_address = this.save_address;
      if (this.is_add == 0) {
        this.form.mobile = this.$cookies.get("user");
        this.form.token = this.$cookies.get("token");
        this.form.id = this.id;
        this.axios
          .get(this.serve + "/personal/edit_inventory", {
            params: this.form
          })
          .then(res => {
            if (res.data.status == "success") {
              this.$message({
                showClose: true,
                type: "success",
                message: "更新成功",
                offset: 400
              });
            } else {
              this.$message({
                showClose: true,
                type: "error",
                message: res.data.msg,
                offset: 400
              });
            }
          });
        return;
      }
      this.axios
        .get(this.serve + "/personal/add_user_inventory", {
          params: this.form
        })
        .then(res => {
          if (res.data.status == "success") {
            this.$message({
              showClose: true,
              type: "success",
              message: "添加成功",
              offset: 400
            });
            var tab = 0;
            if (this.choose_class == "试剂") {
              tab = 1;
            }
            if (this.choose_class == "耗材") {
              tab = 2;
            }
            if (this.choose_class == "仪器") {
              tab = 3;
            }
            if (this.choose_class == "技术服务") {
              tab = 4;
            }
            if (this.choose_class == "抗体") {
              tab = 7;
            }
            this.$router.push({ path: "/user/state/" + tab + "/4" });
          } else {
            this.$message({
              showClose: true,
              type: "error",
              message: res.data.msg,
              offset: 400
            });
          }
        });
    }
  }
};
</script>

<style lang="scss">
#state_detail {
  //
  position: relative;
  .return {
    position: absolute;
    right: 0px;
    top: 0px;
    background-color: #eaedf1;
    width: 96px;
    height: 37px;
    font-size: 16px;
    border: 1px solid rgba(221, 221, 221, 1);
    font-family: MicrosoftYaHei;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    line-height: 39px;
    text-align: center;
    z-index: 3;
    cursor: pointer;
  }
  .el-input__inner {
    padding-left: 0px;
    color: black;
  }
  .save_button {
    display: block;
    margin: 0 auto;
    width: 200px;
    height: 44px;
    background: rgba(51, 51, 51, 0);
    border: 1px solid rgba(226, 33, 28, 1);
    color: rgba(226, 33, 28, 1);
    cursor: pointer;
  }
  .save_button:hover {
    background-color: rgba(226, 33, 28, 1);
    color: white;
  }
  table {
    border-collapse: collapse;
    padding: 0;
    margin: 0 auto;
  }
  .el-input-group__prepend {
    color: black;
    background-color: white;
    border: 0px;
    padding: 5px;
  }
  .el-input__inner {
    border: 0px;
  }
  td {
    width: 176px;
    height: 44px;
    border: 1px solid rgba(221, 221, 221, 1);
  }
  .header .cell {
    padding: 0;
    text-align: center;
    color: #333;
  }
  .header th {
    background-color: #f5faf9;
  }
  .el-link:hover {
    color: #2eacff;
  }
  .el-tabs--border-card > .el-tabs__header .el-tabs__item {
    border-top: 3px solid #e2211c;
  }
  .el-tabs--border-card > .el-tabs__header .el-tabs__item.is-active {
    border-top: 3px solid #e2211c;
  }
}
</style>
